'use strict';

var chunkZ2IA5X5N_js = require('./chunk-Z2IA5X5N.js');
var react = require('react');
var jsxRuntime = require('react/jsx-runtime');

var g=({endpoints:o,style:n,conversationId:i,token:t,autoCompleteControlsConfig:r,utilsConfig:C,onCardClick:l})=>(react.useEffect(()=>{t&&new chunkZ2IA5X5N_js.a(o,i,t,r,C,l).render(document.getElementById("webchat"));},[t]),jsxRuntime.jsx("div",{style:n,id:"webchat"}));

exports.a = g;
